import formatDuration from './formatDuration';
import { parseToMinutes } from './parse-duration-helpers';

export default formatStringDurationToMinutes;

export function formatStringDurationToMinutes(value: string): string {
  const durationInMinutes = parseToMinutes(value);
  return formatDuration(durationInMinutes, { formatUnit: 'minutes' });
}
